/* timba-product.js
   The product page behaviour: variant dropdowns, price, stock badge, SKU table,
   add to basket, tabs, image gallery and the free-delivery basket bar.

   Lifted out of sections/main-product.liquid on 7 Sep 2026 (register item 1.1).
   That file carried 112 KB of inline JavaScript on a 51-variant product, which the
   browser had to parse and evaluate before it could finish painting. 93 KB of that
   was one line: the full Shopify variant JSON, most of whose fields were never read.

   Two things changed and nothing else:
     1. The logic lives here, loaded with defer, so it is cached and off the paint path.
     2. The data arrives as JSON in #tp-product-data instead of as JavaScript source,
        carrying only the nine fields this file actually uses.

   Every function below is intentionally global. The markup calls them from inline
   onclick / onchange / oninput attributes, so this must stay a classic script and
   must NOT be wrapped in an IIFE or loaded as a module.
*/

/* 10 Sep 2026, refurbishment 6.2. The tax rate, tax word, basket words and email come from
   window.TimbaMarket, set in layout/theme.liquid from Theme settings, Market and
   snippets/t.liquid, instead of being typed in here. The fallbacks are the UK values, so
   the page reads exactly as before if the object is ever missing. */
var tpTM = window.TimbaMarket || {};
var tpTaxRate = typeof tpTM.taxRate === 'number' ? tpTM.taxRate : 20;
var tpTaxMult = 1 + tpTaxRate / 100;
var tpTax = tpTM.taxLabel || 'VAT';
var tpAddLabel = tpTM.addToCart || '+ Add to basket';
var tpCartWord = tpTM.cart || 'Basket';
var tpEmail = tpTM.email || 'info@timbasystems.com';

/* ---- data, injected by the section as JSON ---- */
var tpData = { variants: [], options: [], selOpts: [], selected: 0, currency: '£', threshold: 50000 };
try {
  var tpDataEl = document.getElementById('tp-product-data');
  if (tpDataEl) { tpData = JSON.parse(tpDataEl.textContent); }
} catch (e) { /* leave the defaults; the page still renders from Liquid */ }

var tpCurrencySymbol = tpData.currency;
var tpIsGBP = true;
var tpVariants = tpData.variants;
var tpSelected = tpData.selected;
var tpOptions = tpData.options;
var tpSelOpts = tpData.selOpts;
var tpThreshold = tpData.threshold;

/* The four lookup maps the old inline script emitted separately. Built once here from
   the same array, so every line of logic below is unchanged from the inline version. */
var tpVariantMoney = {};
var tpPackQty = {};
var tpStockQty = {};
tpVariants.forEach(function (v) {
  tpVariantMoney[v.id] = v.money;
  tpPackQty[v.id] = v.pack;
  tpStockQty[v.id] = v.stock;
});

/* ---- image navigation ---- */
var tpImgIdx = 0;
var tpImgSrcs = [];
document.addEventListener('DOMContentLoaded', function () {
  var thumbs = document.querySelectorAll('.tp-thumb');
  thumbs.forEach(function (t) { tpImgSrcs.push(t.dataset.src); });
});
function tpSetImg(idx) {
  var thumbs = document.querySelectorAll('.tp-thumb');
  if (idx < 0) idx = thumbs.length - 1;
  if (idx >= thumbs.length) idx = 0;
  tpImgIdx = idx;
  var featImg = document.getElementById('tp-feat-img');
  if (featImg && tpImgSrcs[idx]) featImg.src = tpImgSrcs[idx];
  thumbs.forEach(function (t, i) { t.classList.toggle('active', i === idx); });
}
function tpImgNav(dir) { tpSetImg(tpImgIdx + dir); }

/* ---- cascading dropdowns ---- */
function tpRebuildSelects(driveIdx) {
  var numOpts = tpSelOpts.length;
  for (var gi = 0; gi < numOpts; gi++) {
    var sel = document.getElementById('tp-sel-' + gi);
    if (!sel) continue;
    var valid = [];
    tpVariants.forEach(function (v) {
      var ok = true;
      for (var j = 0; j < gi; j++) {
        if (v.options[j] != tpSelOpts[j]) { ok = false; break; }
      }
      if (ok && valid.indexOf(v.options[gi]) === -1) valid.push(v.options[gi]);
    });
    if (valid.indexOf(tpSelOpts[gi]) === -1 && valid.length) {
      tpSelOpts[gi] = valid[0];
    }
    var allVals = (tpOptions[gi] && tpOptions[gi].values) ? tpOptions[gi].values.slice() : valid.slice();
    sel.innerHTML = '';
    allVals.forEach(function (val) {
      if (valid.indexOf(val) === -1) return;
      var o = document.createElement('option');
      o.value = val; o.textContent = val;
      if (val == tpSelOpts[gi]) o.selected = true;
      sel.appendChild(o);
    });
    var label = document.getElementById('tp-oval-' + (gi + 1));
    if (label) label.textContent = tpSelOpts[gi];
  }
}

function tpSelectChange(oi, val) {
  tpSelOpts[oi] = val;
  tpRebuildSelects(oi);
  var match = tpVariants.find(function (v) {
    return v.options.every(function (o, i) { return o == tpSelOpts[i]; });
  });
  if (match) { tpApplyVariant(match); } else { tpShowUnavailable(); }
}

function tpShowUnavailable() {
  document.getElementById('tp-price').textContent = '—';
  var incEl = document.getElementById('tp-price-inc');
  if (incEl) incEl.textContent = 'Combination not available';
  document.getElementById('tp-sku-val').textContent = '—';
  var atc = document.getElementById('tp-atc');
  if (atc) { atc.disabled = true; atc.textContent = 'Not available'; }
}

function tpSelectVariant(vid) {
  var v = tpVariants.find(function (x) { return x.id == vid; });
  if (!v) return;
  tpSelOpts = v.options.slice();
  tpRebuildSelects(null);
  tpApplyVariant(v);
}

function tpApplyVariant(v) {
  var aliasBox = document.getElementById('tp-hbs-alias');
  var aliasData = document.getElementById('tp-hbs-alias-data');
  if (aliasBox && aliasData) {
    var alias = JSON.parse(aliasData.textContent);
    var codePair = alias.pairs.split('|').find(function (pair) { return pair.split(':')[0] === v.sku; });
    aliasBox.hidden = !codePair;
    if (codePair) document.getElementById('tp-hbs-question').textContent = alias.question.replace('__CODE__', codePair.split(':')[1]);
  }
  tpRefreshConnections(v.id);
  document.querySelectorAll('[data-size-choice]').forEach(function (button) {
    button.setAttribute('aria-pressed', String(button.dataset.sizeChoice === v.options[0]));
  });
  tpSelected = v.id;
  document.getElementById('tp-vid').value = v.id;
  // Keep the "Request a project quote" link pointed at the size on screen,
  // so the quote builder opens with THIS variant already loaded.
  var qlink = document.getElementById('tp-quote-link');
  if (qlink) qlink.href = '/pages/request-a-quote?add=' + v.id + '&h=' + qlink.dataset.handle;
  var p = tpVariantCents(v.id);
  document.getElementById('tp-price').textContent = tpMoney(p);
  var incEl = document.getElementById('tp-price-inc');
  if (incEl) {
    if (tpIsGBP) { incEl.style.display = ''; incEl.textContent = tpMoney(Math.round(p * tpTaxMult)) + ' inc ' + tpTax; }
    else { incEl.style.display = 'none'; }
  }
  document.getElementById('tp-sku-val').textContent = v.sku || '';

  /* B1 (8 Sep 2026): rebuild the UK stock request link from the variant on
     screen. It was rendered once from the first variant and never touched
     again, so the SKU shown and the SKU emailed could disagree, and the
     enquiry landed asking about a size the customer had not chosen. */
  var requestBox = document.getElementById('tp-stock-request');
  if (requestBox) {
    var stocked = v.available && Number(tpStockQty[v.id]) > 0;
    requestBox.hidden = stocked;
    requestBox.style.display = stocked ? 'none' : '';
  }
  var reqLink = document.getElementById('tp-stock-req-link');
  if (reqLink) {
    var title = reqLink.getAttribute('data-title') || '';
    var subject = 'UK stock request: ' + title;
    var body = 'Hi TimbA, I would like this item kept in UK stock for faster delivery (no obligation to buy):'
      + '\r\n\r\nProduct: ' + title
      + '\r\nCode: ' + (v.sku || '')
      + '\r\n\r\nMy name: \r\nHow many I might need (optional): ';
    reqLink.href = 'mailto:' + tpEmail + '?subject=' + encodeURIComponent(subject)
      + '&body=' + encodeURIComponent(body);
  }

  /* B2: keep the address bar on the size being looked at, so a copied link or
     a reload lands on the same screw. replaceState rather than pushState: a
     size change is not a page the back button should have to walk through.
     Every other query parameter is preserved, campaign tags included. */
  try {
    var url = new URL(window.location.href);
    if (url.searchParams.get('variant') !== String(v.id)) {
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
    }
  } catch (e) { /* an old browser simply keeps the address it had */ }
  var pq = tpPackQty[v.id];
  var packEl = document.getElementById('tp-price-pack');
  var unitEl = document.getElementById('tp-price-unit');
  if (pq != null && pq > 0) {
    if (packEl) { packEl.style.display = ''; packEl.innerHTML = '· ' + pq + ' per box'; }
    if (unitEl) { unitEl.style.display = ''; unitEl.textContent = tpMoney(Math.round(p / pq)) + ' per unit'; }
  } else {
    if (packEl) packEl.style.display = 'none';
    if (unitEl) unitEl.style.display = 'none';
  }
  var atc = document.getElementById('tp-atc');
  if (atc) {
    atc.disabled = !v.available;
    atc.textContent = v.available ? tpAddLabel : 'Out of stock';
  }
  var featImg = document.getElementById('tp-feat-img');
  if (v.img && featImg) featImg.src = v.img;
  document.querySelectorAll('.tp-table tbody tr').forEach(function (row) {
    var isSel = row.id == 'tp-row-' + v.id;
    row.classList.toggle('selected', isSel);
    var sc = row.querySelector('.tp-td-sel');
    if (sc) sc.textContent = isSel ? 'Selected' : 'Select';
  });
  // STOCK BADGE: read the injected stock figure, NOT an inventory field off the
  // variant record. Shopify's variant JSON omits inventory_quantity entirely, which
  // is what made this badge wrong before; the number is injected from Liquid instead.
  var badge = document.getElementById('tp-stock-badge');
  if (badge) {
    var qty = tpStockQty[v.id]; if (qty == null) qty = 0;
    if (v.available && qty > 0) {
      badge.className = 'tp-badge tp-badge--stock-yes';
      /* 10 Sep 2026 (refurbishment 5.4): words only. The icon is in the markup and the class picks it. */
      (badge.querySelector('.tp-badge-txt') || badge).textContent = 'In stock';
    } else if (v.available) {
      badge.className = 'tp-badge tp-badge--stock-next';
      (badge.querySelector('.tp-badge-txt') || badge).textContent = 'Supplied to order';
    } else {
      badge.className = 'tp-badge tp-badge--stock-no';
      (badge.querySelector('.tp-badge-txt') || badge).textContent = 'Supplied to order, contact us';
    }
  }
  tpUpdateTotal();
}

function tpQty(d) {
  var inp = document.getElementById('tp-qty');
  var v = parseInt(inp.value) + d;
  if (v < 1) v = 1;
  inp.value = v;
  tpUpdateTotal();
}

function tpUpdateTotal() {
  var qty = parseInt(document.getElementById('tp-qty').value) || 1;
  var vidEl = document.getElementById('tp-vid');
  var vid = vidEl ? parseInt(vidEl.value, 10) : tpSelected;
  if (!vid) return;
  var cents = tpVariantCents(vid);
  document.getElementById('tp-total').textContent = tpMoney(cents * qty);
  var estimate = document.getElementById('tp-delivery-time');
  var variant = tpVariants.find(function (v) { return v.id == vid; });
  if (estimate && variant && tpData.delivery) {
    var delivery = tpData.delivery;
    var days = cents * qty >= tpThreshold ? delivery.freeDays :
      (variant.available && Number(tpStockQty[vid]) >= qty && delivery.express ?
        delivery.expressDays : delivery.standardDays);
    estimate.textContent = variant.available ? 'Estimated delivery: ' + days + ' working days' :
      'Contact us for delivery availability';
  }
}

function tpMoney(cents) {
  return tpCurrencySymbol + (cents / 100).toFixed(2);
}
function tpMoneyToNum(str) {
  if (str == null) return 0;
  var t = String(str).trim();
  if (t.indexOf(',') > -1 && t.indexOf('.') > -1) {
    if (t.lastIndexOf(',') > t.lastIndexOf('.')) { t = t.replace(/\./g, '').replace(',', '.'); }
    else { t = t.replace(/,/g, ''); }
  } else if (t.indexOf(',') > -1) { t = t.replace(',', '.'); }
  return parseFloat(t) || 0;
}
function tpVariantCents(vid) {
  var m = tpVariantMoney[vid];
  if (m == null) { m = tpVariantMoney[String(vid)]; }
  if (m == null) { var v = tpVariants.find(function (x) { return x.id == vid; }); return v ? v.price : 0; }
  return Math.round(tpMoneyToNum(m) * 100);
}

function tpTab(btn, tab) {
  document.querySelectorAll('.tp-tab').forEach(function (t) { t.classList.remove('active'); });
  document.querySelectorAll('.tp-tab-pane').forEach(function (p) { p.classList.remove('active'); });
  btn.classList.add('active');
  document.getElementById('tp-tab-' + tab).classList.add('active');
}

/* ---- adding to the basket ------------------------------------------
   A6 / A7 (8 Sep 2026). Both handlers below used to call r.json() and treat
   whatever came back as a success. fetch only rejects on a network failure,
   never on an HTTP error, so Shopify refusing the line returned a perfectly
   valid JSON error object and the page ran the success path on it: the button
   went back to "+ Add to basket" and nothing was said. The customer believed
   the item was in the basket. See MDN, Window.fetch.

   Every add now reads the status first, shows Shopify's own message when there
   is one, and restores the control on every outcome including the failures. */

function tpAddMessage(status, data) {
  if (data && data.description) return data.description;
  if (data && data.message) return data.message;
  if (status === 422) return 'That quantity is not available for this size.';
  return 'We could not add that to your basket. Please try again.';
}

function tpAtcError(message) {
  var el = document.getElementById('tp-atc-err');
  if (!el) return;
  el.textContent = message || '';
  el.hidden = !message;
}

/* A7: the input carries min="1", but that only binds native form validation,
   and this button posts with fetch instead of submitting the form. So the
   quantity is checked here or it is not checked at all. */
function tpReadQty() {
  var inp = document.getElementById('tp-qty');
  var raw = inp ? String(inp.value).trim() : '';
  if (!/^\d+$/.test(raw)) return null;
  var n = parseInt(raw, 10);
  return n >= 1 ? n : null;
}

/* Shared by both handlers: resolve to the status and the parsed body together,
   whatever the body turns out to be. */
function tpPostAdd(id, quantity) {
  return fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: id, quantity: quantity })
  }).then(function (r) {
    return r.json().catch(function () { return null; }).then(function (data) {
      return { ok: r.ok, status: r.status, data: data };
    });
  });
}

function tpAddToCart() {
  var atc = document.getElementById('tp-atc');
  if (!atc || atc.disabled) return;
  tpAtcError('');

  var qty = tpReadQty();
  if (qty === null) {
    tpAtcError('Enter how many boxes you need, as a whole number of 1 or more.');
    var inp = document.getElementById('tp-qty');
    if (inp) inp.focus();
    return;
  }
  var vidEl = document.getElementById('tp-vid');
  var vid = vidEl ? parseInt(vidEl.value, 10) : 0;
  if (!vid) { tpAtcError('Choose a size first.'); return; }

  atc.disabled = true;
  atc.textContent = 'Adding...';
  function restore() { atc.disabled = false; atc.textContent = tpAddLabel; }

  tpPostAdd(vid, qty)
    .then(function (res) {
      restore();
      if (!res.ok || !res.data || !res.data.id) {
        tpAtcError(tpAddMessage(res.status, res.data));
        return;
      }
      tpUpdateBasket(res.data.title, qty);
    })
    .catch(function () {
      restore();
      tpAtcError('That did not reach us, which usually means the connection dropped. Please try again.');
    });
}


/* ---- SKU table filter ---- */
function tpFilterTable(q) {
  q = (q || '').trim().toLowerCase().replace(/\s+/g, ' ');
  var rows = document.querySelectorAll('#tp-sku-table tbody tr[data-vid]');
  var shown = 0;
  rows.forEach(function (row) {
    var hay = row.getAttribute('data-search') || '';
    var ok = q === '' || q.split(' ').every(function (term) { return hay.indexOf(term) !== -1; });
    row.classList.toggle('tp-row-hidden', !ok);
    if (ok) shown++;
  });
  var noMatch = document.getElementById('tp-no-match');
  if (noMatch) noMatch.classList.toggle('tp-row-hidden', shown > 0);
  var count = document.getElementById('tp-filter-count');
  if (count) count.textContent = 'Showing ' + shown + ' of ' + rows.length;
}

/* ---- adding one box from a row of the size table --------------------
   A8 / A9 (8 Sep 2026). This used to look up "tp-ra-" + variant id to disable
   the button and "tp-rq-" + variant id to read a quantity. Neither id has ever
   been rendered by the section, so the lookups returned null every time: the
   button was never disabled, and two quick clicks sent two separate additions.
   The quantity silently defaulted to one, with nothing on the page saying so.

   Nad's decision, 8 Sep: one click adds one box, and the button says so.
   No per-row quantity controls. tpRowQty went with them, and the .tp-row-qty
   rules were removed from timba-product.css in the same pass.

   The handler is now passed the button that was actually clicked, so it can
   never miss it. */

function tpRowAdd(btn, vid) {
  if (!btn || btn.disabled) return;

  var cell = btn.parentNode;
  var note = cell ? cell.querySelector('.tp-row-msg') : null;
  if (!note && cell) {
    note = document.createElement('span');
    note.className = 'tp-row-msg';
    note.setAttribute('role', 'status');
    cell.appendChild(note);
  }
  function say(text, bad) {
    if (!note) return;
    note.textContent = text || '';
    note.className = 'tp-row-msg' + (bad ? ' tp-row-msg--bad' : '');
  }

  say('');
  btn.disabled = true;
  btn.textContent = 'Adding…';
  function restore(label) { btn.disabled = false; btn.textContent = label || '+ Add 1 box'; }

  tpPostAdd(vid, 1)
    .then(function (res) {
      if (!res.ok || !res.data || !res.data.id) {
        restore();
        say(tpAddMessage(res.status, res.data), true);
        return;
      }
      restore('Added ✓');
      say('1 box added');
      setTimeout(function () { restore(); say(''); }, 2200);
      tpUpdateBasket(res.data.title, 1);
    })
    .catch(function () {
      restore();
      say('That did not reach us. Please try again.', true);
    });
}


/* ---- free-delivery basket bar ---- */
function tpUpdateBasket(addedTitle, addedQty) {
  fetch('/cart.js')
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      var bar = document.getElementById('tp-basket-bar');
      var goods = cart.items.filter(function (i) { return i.handle !== 'timba-delivery'; });
      var total = goods.reduce(function (s, i) { return s + i.final_line_price; }, 0);
      var count = goods.reduce(function (s, i) { return s + i.quantity; }, 0);
      if (count > 0) {
        bar.classList.add('visible');
        var threshold = tpThreshold;
        var pct = Math.min(100, Math.round(total / threshold * 100));
        document.getElementById('tp-basket-fill').style.width = pct + '%';
        document.getElementById('tp-basket-count').textContent = count + (count == 1 ? ' item' : ' items') + ' · ';
        document.getElementById('tp-basket-total').textContent = tpMoney(total) + ' ex ' + tpTax;
        var textEl = document.getElementById('tp-basket-text');
        if (total >= threshold) {
          textEl.innerHTML = tpCartWord + ': <strong>' + tpMoney(total) + '</strong> ex ' + tpTax + ' · <em>FREE delivery unlocked!</em>';
        } else {
          var needed = threshold - total;
          textEl.innerHTML = tpCartWord + ': <strong>' + tpMoney(total) + '</strong> ex ' + tpTax + ' · Add <em>' + tpMoney(needed) + '</em> more for FREE delivery';
        }
      } else {
        bar.classList.remove('visible');
      }
    });
}

document.addEventListener('DOMContentLoaded', function () {
  // Re-apply the selected variant on load so the badge / price / stock state
  // reflect the resolved variant rather than being frozen at render time.
  var startV = tpVariants.find(function (x) { return x.id == tpSelected; });
  if (startV) { tpApplyVariant(startV); }
  tpUpdateTotal();
  tpUpdateBasket();
  tpRebuildSelects(null);
  tpFilterTable('');
});

/* ---- often-bought-with carousel ---- */
function tpOftenSetup() {
  var grid = document.getElementById('tp-often-grid');
  var nav = document.getElementById('tp-often-nav');
  if (!grid) return;
  grid.classList.add('tp-often-scroll');
  if (nav) {
    var overflowing = grid.scrollWidth > grid.clientWidth + 4;
    nav.style.display = overflowing ? 'flex' : 'none';
  }
  tpOftenArrows();
}
function tpOftenArrows() {
  var grid = document.getElementById('tp-often-grid');
  var left = document.getElementById('tp-often-left');
  var right = document.getElementById('tp-often-right');
  if (!grid) return;
  var atStart = grid.scrollLeft <= 2;
  var atEnd = grid.scrollLeft + grid.clientWidth >= grid.scrollWidth - 2;
  if (left) left.style.opacity = atStart ? '0.35' : '1';
  if (right) right.style.opacity = atEnd ? '0.35' : '1';
}
function tpOftenScroll(dir) {
  var grid = document.getElementById('tp-often-grid');
  if (!grid) return;
  var card = grid.querySelector('.tp-often-card');
  var step = card ? (card.offsetWidth + 14) * 2 : 440;
  grid.scrollBy({ left: dir * step, behavior: 'smooth' });
}
document.addEventListener('DOMContentLoaded', function () {
  tpOftenSetup();
  var grid = document.getElementById('tp-often-grid');
  if (grid) grid.addEventListener('scroll', tpOftenArrows, { passive: true });
  window.addEventListener('resize', tpOftenSetup);
});
function tpRefreshConnections(variantId) {
  var section = document.getElementById('tp-connections');
  if (!section) return;
  section.querySelectorAll('[data-connection-variant]').forEach(function (group) {
    group.hidden = group.dataset.connectionVariant !== String(variantId);
  });
  var seen = {}, count = 0;
  section.querySelectorAll('[data-connection-group]').forEach(function (item) {
    var variant = item.closest('[data-connection-variant]');
    item.hidden = false;
    if (variant && variant.hidden) return;
    var id = item.dataset.connectionGroup;
    if (seen[id]) { item.hidden = true; return; }
    seen[id] = true; count++;
  });
  section.hidden = count === 0;
}
document.addEventListener('DOMContentLoaded', function () {
  var root = document.getElementById('tp-root');
  if (!root || !root.classList.contains('tp-refined')) return;
  root.querySelectorAll('[data-size-choice]').forEach(function (button) {
    button.addEventListener('click', function () { tpSelectChange(0, button.dataset.sizeChoice); });
  });
  root.classList.add('tp-ready');
  tpRefreshConnections(tpSelected);
});
